export const howWeWork = [
  {
    title: 'Looking Beyond',
    description: 'We follow opportunity across markets and asset classes, never tied to a single viewpoint.',
    icon: 'ri-compass-3-line',
  },
  {
    title: 'Built on Logic',
    description: 'We invest on reason and commit only to what truly merits it.',
    icon: 'ri-scales-line',
  },
  {
    title: 'A Long View',
    description: 'We invest for the long term and grow value alongside what we back.',
    icon: 'ri-hourglass-line',
  },
];

export const whereWeInvest = [
  {
    num: '01',
    tag: 'Ventures',
    title: 'Technology Ventures',
    description: 'Focusing on enduring software and technology enterprises.',
    bullets: ['Early & growth stage', 'Software-first', 'Global mandate', 'Patient capital'],
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20composition%20of%20luminous%20vertical%20data%20streams%20and%20floating%20code-like%20patterns%20cascading%20through%20a%20deep%20dark%20digital%20void%2C%20soft%20cool%20violet%20and%20silver%20gradients%20suggesting%20software%20architecture%20and%20technological%20depth%2C%20premium%20editorial%20aesthetic%20with%20generous%20negative%20space%2C%20cinematic%20mood%2C%20sophisticated%20modern%20technology%20visualization&width=1000&height=700&seq=liberty-tech-v2&orientation=landscape',
    direction: 'right' as const,
  },
  {
    num: '02',
    tag: 'Public Markets',
    title: 'Public Markets',
    description: 'Capital at work across global financial markets.',
    bullets: ['Global equities', 'Systematic approach', 'Long-biased', 'Risk-managed'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20visualization%20of%20layered%20translucent%20concentric%20rings%20radiating%20outward%20like%20global%20market%20data%20and%20trading%20flows%2C%20cool%20metallic%20blue%20and%20silver%20tones%20with%20subtle%20purple%20highlights%20on%20a%20deep%20charcoal%20background%2C%20premium%20financial%20editorial%20composition%2C%20cinematic%20depth%2C%20sophisticated%20modern%20aesthetic&width=1000&height=700&seq=liberty-markets-v2&orientation=landscape',
    direction: 'left' as const,
  },
  {
    num: '03',
    tag: 'Private Holdings',
    title: 'Private Holdings',
    description: 'Direct stakes in companies across sectors, beyond technology alone.',
    bullets: ['Direct equity', 'Cross-sector', 'Long-term horizon', 'Value-oriented'],
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20editorial%20composition%20of%20multiple%20sculptural%20geometric%20forms%20arranged%20in%20deliberate%20stillness%20on%20a%20dark%20reflective%20surface%2C%20cool%20platinum%20and%20muted%20violet%20ambient%20light%20creating%20subtle%20metallic%20sheen%20and%20depth%2C%20premium%20luxury%20investment%20aesthetic%2C%20deep%20negative%20space%2C%20sophisticated%20corporate%20mood&width=1000&height=700&seq=liberty-holdings-v2&orientation=landscape',
    direction: 'right' as const,
  },
];

export const partnerLogos = [
  'Singapore', 'Technology', 'Software', 'Global', 'Capital', 'Logic',
  'Ventures', 'Markets', 'Holdings', 'Growth',
];